import React from 'react'

const SelectInputWrapper = React.forwardRef((props, ref) => (
  <label className='game-form-label'>
    {props.label}
    <select 
      className={`form-control ` + (props.selectClassName || '')} 
      {..._.omit(props, 'selectClassName')} 
      ref={ref}
      onChange={props.onChange}
    >
      { props.options.map((o, i) => <option key={i} value={o[0]}>{o[1]}</option>) }
    </select>
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default SelectInputWrapper
